import React, { Component } from 'react';
import { __ } from "../Translator";
import Dropdown from "../components/Dropdown";
import Footer from "../components/Footer";
import StepIndicator from "../components/StepIndicator";
import Header from "../components/Header";
import Actions from "../flux/Actions";
import { roundNumber } from "../Helpers";
import AppActions from "../flux/AppActions";
import AppStore from "../flux/AppStore";
import FloatingCustomProductHash from '../components/FloatingCustomProductHash';
import currencySymbol from '../utils/currencySymbol';
import shouldShowPrice from '../utils/shouldShowPrice';
import CountryStore from '../flux/CountryStore';
import CountriesStore from '../flux/CountriesStore';
import dispatchDataLayerEvent, { eventTypes } from '../utils/dispatchDataLayerEvent';


function shouldBookAppointment(state) {
  if (state.customProduct.product.short_tall) {
    return state.customProduct.custom_colored ? (state.size && state.sizeType ? true : null) : false
  }else{
      return state.customProduct.custom_colored ? (state.size !== null ? true : null) : false ;
  }
}

class ModelFit extends Component {
  constructor(props) {
    super(props);

    const customProduct = AppStore.getCustomProduct();

    this.state = {
      customProduct,
      isCustomFit: customProduct.custom_fitted,
      size: customProduct.size,
      sizeType: customProduct.sizeType,
      country: CountriesStore.find(CountryStore.getState()),

      /**
       * true: The Book Appointment button is shown.
       * false: The Go To The Store button is shown.
       * null: no button is shown.
       */
      shouldBookAppointment: null,
    };

    this.props.navigation.onBack(() => {
      this.props.navigation.navigate('modelColor')
    });

    this.onCustomProductUpdate = this.onCustomProductUpdate.bind(this);
    this.goToTheStore = this.goToTheStore.bind(this);
  }

  componentDidMount() {
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdate);

    this.onCustomFitChange(this.state.customProduct.custom_fitted);
    this.onCustomSizeChange(this.state.customProduct.size);
  }

  componentWillUnmount() {
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdate);
  }

  onCustomProductUpdate() {
    const customProduct = AppStore.getCustomProduct();

    this.setState({
      customProduct,
      isCustomFit: customProduct.custom_fitted,
      size: customProduct.size,
      sizeType: customProduct.sizeType,
    });
  }

  onCustomFitChange(isCustomFit) {
    AppActions.updateCustomProduct({ custom_fitted: isCustomFit });

    if (isCustomFit === true) {
       AppActions.updateCustomProduct({ size: null, sizeType: null });
      this.setState({ shouldBookAppointment: true, size: null, sizeType: null });
      this.props.navigation.onNext(() => {
        if (this.state.customProduct.hash) {
          Actions.updateCustomProductFit(this.state.customProduct.hash, this.state.isCustomFit, null);
        }
        if(this.state.customProduct.custom_colored){
          this.props.navigation.navigate('configurator');
        }else{
          this.props.navigation.navigate('bookAppointment');
        }


      });
    } else if (isCustomFit === false) {
      this.setState({ shouldBookAppointment: shouldBookAppointment(this.state) });
      this.props.navigation.onNext(null);
    } else {
      this.setState({ shouldBookAppointment: null });
    }
  }

   onCustomSizeTypeChange(sizeType) {
    AppActions.updateCustomProduct({ sizeType });

    if (sizeType !== null) {
      this.setState({ shouldBookAppointment: this.state.size ? this.state.customProduct.custom_colored : null });
      this.props.navigation.onNext(() => {
        if (this.state.customProduct.hash) {
          Actions.updateCustomProductFit(this.state.customProduct.hash, this.state.isCustomFit, sizeType);
        }
      });
    }
  }

  onCustomSizeChange(size) {
    if(!this.state.customProduct.product.short_tall) {
      AppActions.updateCustomProduct({ sizeType: "STANDARD" });
    }
    AppActions.updateCustomProduct({ size });

    if (size > 0) {
      this.setState({ shouldBookAppointment: this.state.customProduct.custom_colored });
      this.props.navigation.onNext(() => {
        if (this.state.customProduct.hash) {
          Actions.updateCustomProductFit(this.state.customProduct.hash, this.state.isCustomFit, size);
        }
        if(this.state.customProduct.custom_colored){
          this.props.navigation.navigate('configurator');
        }else{
          this.props.navigation.navigate('bookAppointment');
        }
      });
    }
  }

  goToTheStore() {
    dispatchDataLayerEvent({
      event: eventTypes.BUY_ONLINE,
      user_type: window.USER_TYPE,
    });

    const tab = window.open(this.state.customProduct.color.store_url, '_blank');
  }

  render() {
    return (
      <div>
        <Header
          title={__('Configurator')}
          breadcrumb={['Homepage', 'Product', this.state.customProduct.product.name, "design", "fit"]}
        />

        <Footer
          navigation={this.props.navigation}
          productSpecification={this.state.customProduct.product}
          showNextButton={false}
        />

        <FloatingCustomProductHash hash={this.state.customProduct.hash} />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div className="row">
            <div className="col-lg-6 col-lg-offset-3 col-xs-8 col-xs-offset-2">
              <div className="main__hero">
                <h1 className="hero__title">{__('Choose your fit')}</h1>
                <div className="hero__text">
                  <p>{__('Choose a standard size or make your garment adjusted to your own body proportions.')} </p>
                </div>
              </div>

              <Dropdown
                className="dropdown--large"
                title={__('Would you like to customize your fit?')}
                options={[
                  {
                    value: true,
                    disabled: this.state.customProduct.product.custom_fit === 0 || this.state.country.online_purchase === 1 ,
                    online_purchase: 0,
                    text: <span>{__('Yes')} {this.state.customProduct.product.custom_fit !== 0 ?
                      <small>{shouldShowPrice(CountryStore.getState()) ?
                        ' + ' + parseFloat(roundNumber(this.state.customProduct.product.custom_fit_price)).toLocaleString(undefined, { minimumFractionDigits: 2 }) + " " + currencySymbol()
                        : ''}
                      </small>
                      :
                      <span className="alert-message">{__(' - Not available for this model')}</span>
                    }</span>
                  },
                  { value: false,
                    online_purchase: this.state.customProduct.custom_colored === false ? 0 : this.state.country.online_purchase,
                    disabled: this.state.customProduct.product.custom_fit === 1 ,
                    text: <span>{__('No')} {this.state.customProduct.product.custom_fit !== 1 ?
                      <small>{shouldShowPrice(CountryStore.getState()) ?
                        ' + '+parseFloat(roundNumber(0)).toLocaleString(undefined, {minimumFractionDigits: 2}) + ' ' + currencySymbol()
                        : ''}</small>
                      :
                      <span className="alert-message">{__(' - Not available for this model')}</span>
                    }</span>
                  },
                ]}
                selected={this.state.customProduct.custom_fitted}
                onChange={isCustomFit => this.onCustomFitChange(isCustomFit)}
              />
              <div className="sizeAndTypeContainer" style={{display: 'flex'}}>
              {this.state.customProduct.product.short_tall && this.state.isCustomFit === false && this.state.customProduct.custom_colored ? (
                <Dropdown
                  className="dropdown--large"
                  title={__('Choose your size type')}
                  options={this.state.customProduct.product.sizes.map(size => size.size_type).filter((value, index, self) => self.indexOf(value) === index).map(sizeType => ({ value: sizeType, text: sizeType }))}
                  selected={this.state.customProduct.sizeType}
                  onChange={sizeType => this.onCustomSizeTypeChange(sizeType)}
                />
              ) : null}

              {(this.state.customProduct.product.short_tall && this.state.sizeType !== null && this.state.isCustomFit === false) ||
                (!this.state.customProduct.product.short_tall && this.state.isCustomFit === false && this.state.customProduct.custom_colored)
                ? (
                <Dropdown
                  className={"dropdown--large "+(this.state.customProduct.product.short_tall && "u-ml-2") }
                  title={__('Choose your size')}
                  options={this.state.customProduct.product.sizes.filter(size => size.size_type === ( this.state.customProduct.product.short_tall ? this.state.sizeType : "STANDARD" ) ).map(size => ({ value: size.size, text: size.size }))}
                  selected={this.state.customProduct.size}
                  onChange={size => this.onCustomSizeChange(size)}
                />
              ) : null}
              </div>

              <div className="u-ta-center">
                {this.state.shouldBookAppointment === null ? (
                  null
                ) : (
                  this.state.shouldBookAppointment ? (
                    <button
                      className={`btn btn-primary btn-xlg btn-next ${this.state.shouldBookAppointment? '' : 'disabled'}`}
                      onClick={() => this.props.navigation.next()}>
                      {this.state.customProduct.custom_colored === 1 ?__('Customize your garment') : __('Next')}
                    </button>
                  ) : (
                    <button className="btn btn-primary btn-xlg btn-next" onClick={() => this.goToTheStore()}>
                      {__('Go to store')}
                    </button>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ModelFit.defaultProps = {
  customProduct: null,
};

export default ModelFit;



// WEBPACK FOOTER //
// ./src/screens/ModelFit.js